import { styled } from "goober";
import type { MarkdownItem as MarkdownItemType } from "../../../shared/connectors/types";
import { Markdown } from "../Markdown";
import { Text } from "../Text";
import { useRenderWithPlaceholders } from "./renderWithPlaceholders";

export const MarkdownText = styled("div")`
  color: var(--text-secondary);

  p:not(:first-child) {
    margin-top: 16px;
  }

  a {
    color: var(--text-primary);
  }

  strong {
    font-weight: 450;
  }
`;

type Props = {
  item: MarkdownItemType;
  configuration: Record<string, string>;
  connectedAppId: string;
};

export function MarkdownItem({ item, configuration, connectedAppId }: Props) {
  const renderWithPlaceholders = useRenderWithPlaceholders();
  const content =
    typeof item.content === "function"
      ? item.content(configuration)
      : item.content;

  return (
    <MarkdownText>
      <Text variant="text-regular">
        <Markdown>
          {renderWithPlaceholders(content, {
            ...configuration,
            CONNECTED_APP_ID: connectedAppId,
          })}
        </Markdown>
      </Text>
    </MarkdownText>
  );
}
